import { useEffect } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-grid-system";
import Moment from "react-moment";
import Modal from "react-modal";
import { Button } from "../Button";
import { Status } from "../Status";
import { Date } from "../Date";
import EditIcon from "../../assets/img/icons/edit.svg";
import { StyledField } from "../../styles/StyledField";
import { StyledUnitTitle } from "../../styles/StyledUnit";
import { useUnitContext } from "../../context/unitContext";
import { useAppContext } from "../../context/appContext";

export default function UnitHeader({ onClick, id }) {
	const { items } = useAppContext();
	const { name, active, parent, startDate, endDate, upperUnit } = useUnitContext();

	useEffect(() => {
		Modal.setAppElement("body");
	}, []);

	return (
		<Row>
			<Col sm={5}>
				<StyledUnitTitle>
					<Status status={"archive"} />
					<div>
						<h1>{name || ""}</h1>
						{items.userUnits[id] !== undefined && items.userUnits[id].includes("owner") && (
							<Button onClick={onClick} bg={false} icon={EditIcon} small>
								Edit unit
							</Button>
						)}
						{upperUnit && (
							<StyledField>
								<label>upper unit</label>
								<span>{parent.name}</span>
							</StyledField>
						)}
					</div>
				</StyledUnitTitle>
			</Col>
			<Col style={{ overflow: "hidden" }} sm={6} offset={{ sm: 1 }}>
				<Row>
					<Col sm={4} xl={3} xxxl={2}>
						<StyledField mb="4px">
							<label>Unit status</label>
							<span>{active ? "Active" : "Inactive"}</span>
						</StyledField>
					</Col>
					<Col sm={4} xl={3} xxxl={2}>
						<StyledField mb="12px">
							<label>Start Date</label>
							<Date>
								<Moment format="YYYY-MM-DD">{startDate}</Moment>
							</Date>
						</StyledField>
					</Col>
					<Col sm={4} xl={3} xxxl={2}>
						<StyledField mb="12px">
							<label>End Date</label>
							<Date>
								<Moment format="YYYY-MM-DD">{endDate}</Moment>
							</Date>
						</StyledField>
					</Col>
				</Row>
				<Row>
					<Col>
						<StyledField mb="12px">
							<label>Upper unit</label>
							<span>{parent ? parent.name : "No upper unit"}</span>
						</StyledField>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}

UnitHeader.propTypes = {
	data: PropTypes.object,
	onClick: PropTypes.func,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
